export class RaceRoute {
  constructor(public raceId?: number,
              public route?: string,
              public content?: string) {
  }
}
